var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-section"},[_c('div',{ref:"map",attrs:{"id":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }